<template>
  <div class="statistics">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label name></el-tab-pane>
      <el-tab-pane label="区域统计" name="area" :disabled="abledVal">
      </el-tab-pane>
      <el-tab-pane label="个人统计" name="personal" :disabled="abledVal">
      </el-tab-pane>
    </el-tabs>
    <div class="con-box">
      <div class="con-search">
        <el-form
          size="mini"
          :inline="true"
          :model="queryForm"
          ref="queryForm"
          class="input-form-inline"
          @submit.native.prevent
        >
          <div>
            <el-form-item prop="areaId" class="r-10" v-if="flag == 1">
              <el-select
                v-model="queryForm.areaId"
                clearable
                filterable
                placeholder="选择区域"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.areaId"
                  :label="item.name"
                  :value="item.areaId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="r-10" prop="username" v-else>
              <el-input
                v-model="queryForm.username"
                @keyup.enter.native="query"
                placeholder="用户名"
              ></el-input>
            </el-form-item>
            <el-form-item prop="time" class="date-input r-10">
              <date-picker 
                :startTime="queryForm.startTime" 
                :endTime="queryForm.endTime" 
                @changeStart="changeStart" 
                @changeEnd="changeEnd">
              </date-picker>
            </el-form-item>
            <el-button
              v-if="hasPerm('statistics:data:power')"
              type="primary"
              @click="query"
              >查询</el-button
            >
            <el-button v-if="hasPerm('statistics:data:power')" @click="reset"
              >取消</el-button
            >
          </div>
        </el-form>
      </div>
      <div class="con-tab">
        <el-row :gutter="20">
          <el-col class="tab-box" :xl="8" :lg="12">
            <div class="grid-content bg-purple">
              <div class="bg iconfont icon-historical-data"></div>
              <div class="text-box">
                <p class="text-data">{{ $judgeEmpty(tabData.powerNum) }}</p>
                <p class="text-name">发电量（KW·H）</p>
              </div>
            </div>
          </el-col>
          <el-col class="tab-box" :xl="8" :lg="12">
            <div class="grid-content bg-purple">
              <div class="bg iconfont icon-historical-data"></div>
              <div class="text-box">
                <p class="text-data">{{ $judgeEmpty(tabData.powerTime) }}</p>
                <p class="text-name">发电时长</p>
              </div>
            </div>
          </el-col>
          <el-col class="tab-box" :xl="8" :lg="12">
            <div class="grid-content bg-purple">
              <div class="bg iconfont icon-historical-data"></div>
              <div class="text-box">
                <p class="text-data">{{ $judgeEmpty(tabData.powerOil) }}</p>
                <p class="text-name">发电油耗（L）</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="time-change">
        <span style="margin-right:10px">{{ areaName }}</span>
        <el-select class="time" v-model="year" @change="yearChange">
          <el-option
            v-for="item in timeList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        月发电量（KW·H）
      </div>
      <div class="area-chart" ref="chart"></div>
    </div>
  </div>
</template>
<script>
import DatePicker from "@/components/DatePicker.vue"
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      activeName: "area",
      myChart: "",
      tabData: {},
      areaList: [],
      timeList: [],
      queryForm: {
        areaId: "",
        username: "",
        startTime:'',
        endTime:''
      },
      flag: 1,
      year: "",
      datax: [],
      datay: [],
      areaName: "",
      loading: "",
      oldName: "",
      //判断两个接口都调用结束
      textData: 0,
      chartData: 0,
      abledVal: false,
    }
  },
  created() {
    this.getAreaList()
    this.getYearList()
  },
  mounted() {
    //加loading效果
    let _this = this
    this.$nextTick(() => {
      _this.initCharts()
    })
    this.myChart = this.$echarts.init(this.$refs.chart)
    let judge = this.hasPerm("statistics:data:power")
    if (judge) {
      this.getDataFun()
    }
  },
  methods: {
    changeStart(val){
      this.queryForm.startTime = val
    },
    changeEnd(val){
      this.queryForm.endTime = val
    },
    query() {
      if (this.flag == 2 && this.queryForm.username == "") {
        this.$message.warning("请输入需要查询的用户名")
        return
      }
      this.getDataFun()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      if (this.flag == 2 && this.queryForm.username == "") {
        this.$message.warning("请输入需要查询的用户名")
        return
      }
      this.getDataFun()
    },
    handleClick(tab, event) {
      this.$resetForm(this, "queryForm")
      this.areaName = ""
      if (tab.name == "area") {
        this.flag = 1
        this.getDataFun()
      } else {
        this.flag = 2
        this.datax = []
        this.datay = []
        this.tabData = {}
        this.initCharts()
      }
      this.oldName = tab.name
      console.log(tab, event)
    },
    async getAreaList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/sys/area/options")
      if (res.code == 1) {
        _this.areaList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async getYearList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/statistics/data/year")
      if (res.code == 1) {
        _this.timeList = res.data.reverse()
        _this.year = _this.timeList[0]
      } else {
        _this.$message.warning(res.msg)
      }
    },
    getDataFun() {
      this.textData = 0
      this.chartData = 0
      this.abledVal = true
      this.getData()
      this.getPowerCharts()
    },
    async getData() {
      let _this = this
      this.loading = this.$loading({
        lock: false,
        text: "Loading",
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector(".con-tab"),
      })
      let obj = {}
      obj.areaId = _this.queryForm.areaId
      obj.username = _this.queryForm.username
      obj.startTime = _this.queryForm.startTime
      obj.endTime = _this.queryForm.endTime
      let { data: res } = await _this.$axios.get("/api/statistics/data/power", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tabData = res.data
        _this.areaName = res.data.areaName
      } else {
        _this.$message.warning(res.msg)
      }
      _this.loading.close()
      // 当前接口调用完成，判断另一个接口情况
      _this.textData = 1
      if (_this.chartData == 1) {
        _this.abledVal = false
      }
    },
    async getPowerCharts() {
      let _this = this
      _this.myChart.showLoading({
        text: "loading",
        color: "#c23531",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0,
      })
      let obj = {}
      _this.datax = []
      _this.datay = []
      obj.areaId = _this.queryForm.areaId
      obj.username = _this.queryForm.username
      obj.chartsTime = _this.year
      let { data: res } = await _this.$axios.get(
        "/api/statistics/data/power/charts",
        {
          params: obj,
        }
      )
      if (res.code == 1) {
        for (let i = 0; i < res.data.length; i++) {
          _this.datax.push(res.data[i].date)
          _this.datay.push(res.data[i].value)
        }
        _this.initCharts()
      } else {
        _this.$message.warning(res.msg)
      }
      _this.myChart.hideLoading()
      // 当前接口调用完成，判断另一个接口情况
      _this.chartData = 1
      if (_this.textData == 1) {
        _this.abledVal = false
      }
    },
    yearChange() {
      if (this.flag == 2 && this.queryForm.username == "") {
        this.$message.warning("请输入需要查询的用户名")
        return
      }
      this.getPowerCharts()
    },
    initCharts() {
      let _this = this
      _this.myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            label: {
              backgroundColor: "#0094ff",
            },
          },
        },
        legend: {
          data: ["发电量"],
          orient: "vertical",
          x: "center", //可设定图例在左、右、居中
          y: "bottom",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: _this.datax,
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },

          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "发电量",
            data: _this.datay,
            type: "line",
            itemStyle: {
              color: "#0094ff",
            },
            areaStyle: {
              color: "rgba(0,148,255,0.4)",
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
          },
        ],
      })
      window.addEventListener("resize", () => {
        _this.myChart.resize()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.statistics {
  margin: 20px;
  height: calc(100% - 40px);
  overflow: auto;
  background-color: #f8f8f8;
  box-sizing: border-box;
}
.el-tabs /deep/ .el-tabs__header {
  background: #fff;
  margin-bottom: 20px;
}
.el-tabs /deep/ #tab-0 {
  padding: 0;
  height: 0;
}
.con-box {
  background: #fff;
  height: calc(100% - 60px);
  overflow-y: auto;
  padding: 0 10px;
}
.con-search {
  padding: 0 10px;
}
.con-tab /deep/ {
  overflow: hidden;
  .el-col {
    padding: 0 10px !important;
    height: 120px;
  }
}
.area-chart {
  width: 100%;
  height: 360px;
}
.date-input {
  /deep/ .el-form-item__content{
    width:480px;
  }
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg {
  width: 56px;
  height: 56px;
  font-size: 56px;
  color: #0094ff;
  margin-right: 34px;
  display: inline-block;
}
.tab-box {
  margin-bottom: 20px;
}
.text-box {
  display: inline-block;

  .text-data {
    font-size: 32px;
    color: #0094ff;
  }
  .text-name {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
}
.iconfont {
  width: 56px;
  height: 56px;
}
.bg-purple {
  width: 100%;
  height: 100%;
  padding: 30px;
  background: #f4f4f4;
  box-sizing: border-box;
  border-radius: 6px;
}
.time-change /deep/ {
  padding-left: 10px;
  .time {
    width: 90px;
    height: 32px;
    margin-right: 10px;
    .el-input__inner {
      height: 32px;
    }
    .el-input__icon {
      line-height: 32px;
    }
  }
}
.time-change {
  font-size: 14px;
}
</style>
